import { createFileRoute } from '@tanstack/react-router'

import { RouteModal } from '@/components/route-modal'

import { CreateBusinessCardForm } from '../../../business-cards/-create-form'

export const Route = createFileRoute('/_authenticated/_general/companies/$companyUuid/business-cards/create')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.BusinessCards.CreateTitle()
	}
})

function RouteComponent() {
	const { companyUuid } = Route.useParams()
	return (
		<RouteModal asDrawer requiresData loader={async api => await api.getCompany({ path: { companyUuid } })}>
			{company => <CreateBusinessCardForm lockedCompany={{ uuid: company.uuid, name: company.name }} />}
		</RouteModal>
	)
}
